import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  getDeviceTypeFromUserAgent,
  getNetworkType,
  trackCleavertapEvent,
} from "../../utils/analyics/analyticsHelper";
import { ANALYTICS_EVENTS } from "../../utils/analyics/analyticsEvents";
import { apiMetricsManager } from "../../utils/analyics/apiMetricsManager";
import { EXCLUDED_ROUTES_FOR_ANALYTICS } from "../../utils/analyics/analyticsConstant";

const PagePerformanceTracker = () => {
  const location = useLocation();

  const routeStartTimeRef = useRef<number>(0);
  const routeLoadTimeRef = useRef<number | null>(null);

  useEffect(() => {
    const isExcludedRoute = EXCLUDED_ROUTES_FOR_ANALYTICS.some((route) =>
      location.pathname.startsWith(route),
    );

    if (isExcludedRoute) return;

    // Reset metrics for new page
    apiMetricsManager.startNewPage();

    // Start timing
    routeStartTimeRef.current = performance.now();
    routeLoadTimeRef.current = null;

    let raf1: number;
    let raf2: number;

    // Measure visual route load time
    raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => {
        routeLoadTimeRef.current =
          performance.now() - routeStartTimeRef.current;
      });
    });

    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);

      // ===== ROUTE EXIT SUMMARY =====
      const timeSpent =
        performance.now() - routeStartTimeRef.current;

      const { total, failed, slow, avg } =
        apiMetricsManager.getMetrics();

      const payload = {
        Page_Name: location.pathname,

        Route_Load_Time_Milliseconds: routeLoadTimeRef.current
          ? Math.round(routeLoadTimeRef.current)
          : 0,
        Time_Spent_Milliseconds: Math.round(timeSpent),
        Device_Type: getDeviceTypeFromUserAgent(),
        Network_Type: getNetworkType(),
        Image_Count: document.images.length,
        API_Calls: total,
        Failed_API_Calls: failed,
        Slow_API_Calls: slow,
        Avg_API_Duration: avg,
      };

      trackCleavertapEvent(
        ANALYTICS_EVENTS.Page_Performance,
        payload,
      );
    };
  }, [location.pathname]);

  return null;
};

export default PagePerformanceTracker;
